import React from 'react';
import { Provider } from 'react-redux';

import App from '../App';
import ErrorBoundary from '../Errors/ErrorBoundary';

const Root = ({ store }) => (
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>
);

export default Root;
